/* eslint-disable */
export default {
  lang: {
    zh: '中文',
    en: 'English',
    sp: 'Español'
  },
  nav: {
    home: 'INICIO',
    product: 'PRODUCTROS',
    news: 'NOTICIAS',
    aboutUs: 'SOBRE NOSOTROS',
    contactUs: 'CONTACTANOS',
    tips: 'Soporte de búsqueda por modelo o parte del vehículo'
  },
  title: {
    oneDream: 'un sueño',
    guestDepartment: 'DEPARTAMENTO DE INVITADOS',
    contact: 'contacto',
    contactUs: 'Contactanos',
    QRCode: 'Código QR',
    product: 'Productos',
    pressCenter:'Centro de prensa',
    companyProfile: 'Perfil de la Compañia',
    developmentPath: 'Ruta de desarrollo',
    honor: 'Honor',
    aboutUs: 'sobre nosotros'
  },
  other: {
    keyWords: 'palabras clave',
    search: 'Search',
    readMore: 'Lee mas',
    noMore: 'No más',
    selectProduct: 'Seleccionar categoría de producto',
    choose: 'Elegir la categoría',
    prompt: 'aviso',
    contactService: `contacta con nosotros por correo sales@dertparts.com para obtener los catálogos electrónicos`
  },
  product: {
    classify: 'buscar',
    noDataText: 'Sin datos'
  }
}